import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Container,
  IconButton,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import SaveAltOutlinedIcon from '@material-ui/icons/SaveAltOutlined';
import { useCallback, useEffect, useState } from 'react';
import CommissionSalesService, { IProposalWeBroPayInfo } from '../../../services/CommissionSalesService';
import { InputsContent, PagadoriaAccordionContainer, PagadoriaSummaryInfo } from '../EditarProposta/styles';

interface PagadoriaStatusAccordionProps {
  codMega: string;
}

const PagadoriaStatusAccordion = ({codMega}: PagadoriaStatusAccordionProps) => {
  const [weBroPaySalesInfo, setWeBroPaySalesInfo] = useState<IProposalWeBroPayInfo | null>(null)
  const [hasWeBroPaySales, setHasWeBroPaySales] = useState(false)

  let totalParcelaCount = 0;

  const getWeBroPaySales = useCallback(async () => {
    try {
      const response = await CommissionSalesService.getWebropaySales(codMega)
      setWeBroPaySalesInfo(response.weBroPaySales)
    } catch (error) {
      console.error('Erro ao buscar as comissões WeBroPay:', error);
    }
  },[codMega])

  const formatWeBroPayDate = (dateStr: string) => {
    const [year, month, day] = dateStr.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('pt-BR');
  }

  useEffect(() => {
    getWeBroPaySales();
  }, [codMega, getWeBroPaySales]);

  useEffect(() => {
    if (weBroPaySalesInfo && weBroPaySalesInfo.sales.length > 0) {
      setHasWeBroPaySales(true);
    } else {
      setHasWeBroPaySales(false);
    }
  }, [weBroPaySalesInfo]);

  return hasWeBroPaySales && (
    <InputsContent className="acordion-1">
        <Accordion className="acordion">
            <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="acordion-summary-pagadoria"
            >
            <PagadoriaSummaryInfo>
                <Typography className="anexar-documentos">
                <AccountBalanceWalletOutlinedIcon />
                </Typography>
                <Typography className="pagadoria-accordion-title">Pagadoria - Status Comissões</Typography>
                {hasWeBroPaySales && weBroPaySalesInfo && (
                <>
                    <Container>
                    <Typography variant="subtitle2">Recebedor (a)</Typography>
                    <Typography variant="body1">{weBroPaySalesInfo.nomeRecebedor}</Typography>
                    </Container>
                    <Container>
                    <Typography variant="subtitle2">Cliente</Typography>
                    <Typography variant="body1">{weBroPaySalesInfo.nomeCliente}</Typography>
                    </Container>
                </>
                )}
            </PagadoriaSummaryInfo>
            </AccordionSummary >
            <AccordionDetails className="pagadoria">
            {hasWeBroPaySales && weBroPaySalesInfo && (
                <PagadoriaAccordionContainer>
                {weBroPaySalesInfo.sales.map((sale: any) => (
                    <Container key={sale.idVenda} className={`card-venda ${sale.pagamentoLiberado ? 'liberado' : 'bloqueado'}`}>
                    <Container
                    className="status-chip"
                    >
                        {sale.pagamentoLiberado ? 'LIBERADO' : 'BLOQUEADO'}
                    </Container>
                    {sale.installments.map((parcela: any) => {
                    totalParcelaCount += 1;
                    return (
                        <Container key={parcela.idParcela} className="parcela-row">
                        <Container className="coluna">
                            <IconButton aria-label="download" edge="start" color="inherit" href={parcela.urlBoleto} target="_blank">
                            <SaveAltOutlinedIcon fontSize="medium" />
                            </IconButton>
                        </Container>
                        <Typography>{totalParcelaCount}°</Typography>

                        <Container className="coluna value-column">
                            <Typography className="valor">
                            {new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }).format(parcela.valor)}
                            </Typography>
                            <Typography variant="body2">Valor Parcela</Typography>
                        </Container>

                        <Container className="coluna status-column">
                            <Typography className={`status ${parcela.pago ? 'pago' : 'pendente'}`}>
                            {parcela.pago ? 'Pago' : 'Pendente'}
                            </Typography>

                            {parcela.pago ? (
                            <Typography variant="body2">
                                Pago em {formatWeBroPayDate(parcela.dataPagamentoParcela)}
                            </Typography>
                            ) : (
                            <Typography variant="body2">
                                Pagamento Cliente
                            </Typography>
                            )}
                        </Container>

                        <Container className="coluna due-date-column">
                            <Typography className="valor">
                            {formatWeBroPayDate(parcela.dataVencimentoParcela)}
                            </Typography>
                            <Typography variant="body2">Vencimento</Typography>
                        </Container>
                        </Container>
                    );
                    })}
                </Container>
                ))}
                <Container className="footer-accordion-content">
                    <Typography className="total-comissao">
                        Comissão Total <strong>
                        {new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        }).format(weBroPaySalesInfo.valorTotal || 0)}
                        </strong>
                    </Typography>
                </Container>
            </PagadoriaAccordionContainer>
            )}
            </AccordionDetails>
        </Accordion >
    </InputsContent >
  );
};

export default PagadoriaStatusAccordion;
